//import
// initial state
var state = {
  isPrintConsole: true,
  progress: 0,
  showImageLog: true,
  global: {
    showPlannedWell: false,
    showInformationView: false,
    showStatusBar: false,
    defaultAppTitle: "Geosteering Training Simulator (Beta)",
    scenarios: [],
    scenarioId: "",
    sessionId: "",
    serverDialog: true,
    scenarioDialog: false,
    siteComDialog: false,
    connectedSiteCom: false
  },
  siteComUserInfo: {
    username: "",
    password: ""
  },
  scenarioJSON: null,
  vtk3DView: {
    showDecisionPoints: true,
    showDrilledPath: true,
    showGrid: true
  },
  logsView: {
    secondCurtainOpacity: 0.85
  },
  mapsView: {}
}; // getters

var getters = {
  appTitle: function appTitle(state) {
    if (state.global.scenarioId == "") {
      return state.global.defaultAppTitle;
    } else {
      return "Geosteering Training Simulator - " + state.global.scenarioId + " (Beta)";
    }
  },
  curtainPropertyJSON: function curtainPropertyJSON(state) {
    if (!state.scenarioJSON || !state.scenarioJSON.hasOwnProperty("curtainGridCProperties")) {
      return [];
    } else {
      return state.scenarioJSON.curtainGridCProperties;
    }
  },
  defaultSelectedCurtainProperties: function defaultSelectedCurtainProperties(state) {
    if (!state.scenarioJSON || !state.scenarioJSON.hasOwnProperty("defaultSelectedCurtainProperties")) {
      return "";
    } else {
      return state.scenarioJSON.defaultSelectedCurtainProperties;
    }
  },
  defaultSelectedLogProperties: function defaultSelectedLogProperties(state) {
    if (!state.scenarioJSON || !state.scenarioJSON.hasOwnProperty("defaultSelectedLogProperties")) {
      return "";
    } else {
      return state.scenarioJSON.defaultSelectedLogProperties;
    }
  },
  defaultSelectedImageLogProperty: function defaultSelectedImageLogProperty(state) {
    if (!state.scenarioJSON || !state.scenarioJSON.hasOwnProperty("defaultSelectedImageLogProperty")) {
      return "";
    } else {
      return state.scenarioJSON.defaultSelectedImageLogProperty;
    }
  }
}; // actions

var actions = {}; // mutations

var mutations = {
  // state.global
  updateShowPlannedWell: function updateShowPlannedWell(state, value) {
    state.global.showPlannedWell = value;
  },
  updateShowImageLog: function updateShowImageLog(state, value) {
    state.showImageLog = value;
  },
  updateShowInformationView: function updateShowInformationView(state, value) {
    state.global.showInformationView = value;
  },
  updateShowStatusBar: function updateShowStatusBar(state, value) {
    state.global.showStatusBar = value;
  },
  updateServerDialog: function updateServerDialog(state, value) {
    state.global.serverDialog = value;
  },
  updateScenarios: function updateScenarios(state, value) {
    state.global.scenarios = value;
  },
  updateScenarioDialog: function updateScenarioDialog(state, value) {
    state.global.scenarioDialog = value;
  },
  updateSiteComDialog: function updateSiteComDialog(state, value) {
    state.global.siteComDialog = value;
  },
  updateConnectedSiteCom: function updateConnectedSiteCom(state) {
    state.global.connectedSiteCom = !state.global.connectedSiteCom;
  },
  updateScenarioId: function updateScenarioId(state, value) {
    state.global.scenarioId = value;
  },
  updateSessionId: function updateSessionId(state) {
    var currdate = new Date();
    var d = ["0" + (currdate.getMonth() + 1), "0" + currdate.getDate(), "0" + currdate.getHours(), "0" + currdate.getMinutes(), "0" + currdate.getSeconds()].map(function (component) {
      return component.slice(-2);
    });
    state.global.sessionId = currdate.getFullYear() + d.join("");
  },
  updateSiteComUserInfo: function updateSiteComUserInfo(state, objInput) {
    state.siteComUserInfo[objInput.key] = objInput.value;
  },
  updateProgress: function updateProgress(state, value) {
    state.progress = state.progress + value;
  },
  // state.scenarioJSON
  updateScenarioJSON: function updateScenarioJSON(state, value) {
    state.scenarioJSON = value;
  },
  // state.vtk3DView
  updateShowDecisionPoints: function updateShowDecisionPoints(state, value) {
    state.vtk3DView.showDecisionPoints = value;
  },
  updateShowDrilledPath: function updateShowDrilledPath(state, value) {
    state.vtk3DView.showDrilledPath = value;
  },
  updateShowGrid: function updateShowGrid(state, value) {
    state.vtk3DView.showGrid = value;
  },
  // state.logsView
  updateSecondCurtainOpacity: function updateSecondCurtainOpacity(state, value) {
    state.logsView.secondCurtainOpacity = value;
  }
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};